module.exports = __webpack_public_path__ + "media/images/lineup__stat__totalScore-54fde5932ea67c8f2fb6a660bdd32984.png";